var ContentScores = /** @class */ (function () {
    function ContentScores() {
    }
    // Default scoring
    ContentScores.scoreForDefaultContent = 0.05;
    ContentScores.scoreForDefaultStructure = 0.1;
    ContentScores.scoreForDefaultIndustry = 0.3;
    ContentScores.scoreForDefaultSpecificIndustry = 0.4;
    // Signature scoring
    ContentScores.scoreForFullSignature = 4;
    ContentScores.scoreForNoIndustrySignature = 3;
    ContentScores.scoreForNoStructureSignature = 2;
    ContentScores.scoreForNoStructureAndIndustrySignature = 1;
    // Template scoring
    ContentScores.scoreForUsingDefaultValues = 1;
    ContentScores.scoreForUsingPlaceholderValues = 1;
    ContentScores.scoreForUsingTemplateValues = 1;
    return ContentScores;
}());
export { ContentScores };
//# sourceMappingURL=contentScores.js.map